// Modules
import { gql } from '@apollo/client'

// Query: Account > Account
const ACCOUNT = gql`
	query Account {
		user {
			belEspritOnboardedAt
			email
			firstName
			id
			lastName
			memberships {
				teamId
				role
			}
			ownedTeamsIds
			phoneNumber
			phoneNumberVerifiedAt
			phoneNumberVerifiedBefore
			team {
				id
			}
			teams {
				displayName
				id
				isPersonal
				maxAccessKeysCount
				name
			}
		}
	}
`

// Export
export default ACCOUNT
